<template lang="html">
  <div class="modal-bg">
    <div class="modal modal--feedback">
      <img class="modal-icon" :src="iconSrc" alt="" />
      <p class="modal-title">
        {{ mainTitle }}
      </p>
      <p class="modal-text text">
        {{ subTitle }}
      </p>
      <button-component md primary @click="onConfirm">
        {{ okTitle }}
      </button-component>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ButtonComponent from "./ButtonComponent.vue"
import errorIcon from "@/assets/images/modal-icon-times-circle.svg"
import successIcon from "@/assets/images/modal-icon-check-circle.svg"
import { computed } from "vue"

interface FeedbackModalProps {
  mainTitle: string
  subTitle: string
  okTitle: string
  success: boolean
}

const props = withDefaults(defineProps<FeedbackModalProps>(), {
  mainTitle: "Are you sure?",
  subTitle: "Are you sure?",
  okTitle: "OK",
  success: false
})

const emit = defineEmits(["confirm"])

const iconSrc = computed(() => {
  return props.success ? successIcon : errorIcon
})

const onConfirm = () => {
  emit("confirm")
}
</script>
